import React, { Component } from "react";
import { FiChevronDown } from "react-icons/fi";
import { IoTrashBinOutline } from "react-icons/io5";
import ConnectionsModal from "../../../../base/features/blocks/ConnectionsModal";
import Image from "../../../../base/features/micro/Image";
import Spinner from "../../../../base/features/micro/Spinner";
import { get_custom_product, rejectCustomProduct } from "./services";

class CustomProductDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shopUid: window.location.pathname.split("/")[2],
      customProductId: window.location.pathname.split("/")[4],
      customProduct: null,
      connectionsModal: false,
    };
  }

  componentDidMount() {
    this.getCustomProduct();
  }
  getCustomProduct() {
    get_custom_product(this.state.shopUid, this.state.customProductId).then(
      (items) => {
        items && this.setState({ customProduct: items });
      }
    );
  }
  rejectProduct() {
    let params = {
      status: 2,
    };
    rejectCustomProduct(this.state.shopUid, this.state.customProductId, params);
  }
  render() {
    return this.state.customProduct ? (
      <div className="row mx-0 rounded14 bg-light-gray p-3 mb-4">
        {this.state.customProduct.medias.map((media, m) => (
          <div className="col-4 px-1 mb-2 text-center">
            <img
              alt={`product-pic`}
              height="80"
              className=""
              src={media.file}
            />
          </div>
        ))}
        <div className="col-12 px-0 mt-3">
          <p className="fw-bold">{this.state.customProduct.des}</p>
        </div>
        <div
          className="col-12 rounded14 border bg-white px-3 py-2-3"
          onClick={() => this.setState({ connectionsModal: true })}
        >
          <div className="row mx-0">
            <div className="col-auto px-1">
              <Image
                extraClassName={"p-2 bg-color-main rounded-2"}
                imgClassName={"rounded14 img-cover"}
                imageHeight={"35"}
                imageAlt={"profile-img"}
                imageUri={
                  this.state.customProduct.user.image &&
                  this.state.customProduct.user.image
                }
              />
            </div>
            <div className="col px-1 align-self-center">
              <p className="mb-0 fw-bold">
                {this.state.customProduct.user.name}
              </p>
            </div>
            <div className="col-auto px-1 align-self-center">
              <FiChevronDown size={20} />
            </div>
          </div>
        </div>
        <div
          className="col-12 mt-2 border rounded14 border-danger text-danger bg-white px-3 py-2-3"
          onClick={() => this.rejectProduct()}
        >
          <div className="row mx-0">
            <div className="col px-1 align-self-center">
              <p className="mb-0 fw-bold">رد کردن سفارش</p>
            </div>
            <div className="col-auto px-1 align-self-center">
              <IoTrashBinOutline size={28} />
            </div>
          </div>
        </div>
        {this.state.connectionsModal && (
          <ConnectionsModal
            phone={this.state.customProduct.user.phone}
            connectionsModalChange={(value) =>
              this.setState({ connectionsModal: value })
            }
            connectionsModal={this.state.connectionsModal}
          />
        )}
      </div>
    ) : (
      <Spinner />
    );
  }
}

export default CustomProductDetail;
